import { Injectable, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiService, DataTable } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicantsService implements OnDestroy {
  private destroy$ = new Subject<void>();

  getCandidatesApplicants = (body = {}, params = {}) =>
    this.api
      .post<DataTable<any>>({
        path: 'applicants/applicants',
        params,
        body
      })
      .pipe(takeUntil(this.destroy$));

  acceptApplicants = (candidates: any[], jobId?: number) =>
    this.api
      .post<any>({
        path: 'applicants/accept-applicant',
        body: { candidates, jobId }
      })
      .pipe(takeUntil(this.destroy$));

  constructor(private api: ApiService) {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
